import { EyeOff, UsersRound } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export default function RecipientFields({ to, cc, bcc, showCopies, onToggleCopies, onToChange, onCcChange, onBccChange }) {
  return (
    <div className="space-y-3" data-testid="compose-recipient-fields">
      <div className="space-y-1.5">
        <div className="flex items-center justify-between gap-3">
          <label className="text-xs font-semibold text-muted-foreground" htmlFor="compose-to-input">To</label>
          <Button type="button" variant="ghost" size="sm" className="h-7 rounded-full px-2.5 text-xs" onClick={onToggleCopies} data-testid="compose-toggle-cc-bcc-button">
            <UsersRound className="w-3.5 h-3.5 mr-1" /> {showCopies ? 'Hide Cc/Bcc' : 'Cc/Bcc'}
          </Button>
        </div>
        <Input
          id="compose-to-input"
          placeholder="recipient@example.com, another@example.com"
          value={to}
          onChange={event => onToChange(event.target.value)}
          className="rounded-lg"
          data-testid="compose-to-input"
        />
      </div>

      {showCopies && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="compose-cc-bcc-fields">
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-muted-foreground" htmlFor="compose-cc-input">Cc</label>
            <Input id="compose-cc-input" placeholder="Visible copy recipients" value={cc} onChange={event => onCcChange(event.target.value)} className="rounded-lg" data-testid="compose-cc-input" />
          </div>
          <div className="space-y-1.5">
            <div className="flex items-center justify-between gap-2">
              <label className="text-xs font-semibold text-muted-foreground" htmlFor="compose-bcc-input">Bcc</label>
              <span className="inline-flex items-center gap-1 text-[10px] text-muted-foreground" data-testid="compose-bcc-privacy-label"><EyeOff className="w-3 h-3" /> Hidden from recipients</span>
            </div>
            <Input id="compose-bcc-input" placeholder="Private copy recipients" value={bcc} onChange={event => onBccChange(event.target.value)} className="rounded-lg" data-testid="compose-bcc-input" />
          </div>
        </div>
      )}
    </div>
  );
}